import api, { authService } from './api';

const config = () => ({ headers: { Authorization: `Bearer ${authService.getToken()}` } });

export const contactsService = {
  list: async (params) => (await api.get('/contacts', { ...config(), params })).data,
  update: async (contactId, payload) => (await api.patch(`/contacts/${encodeURIComponent(contactId)}`, payload, config())).data,
  create: async (payload) => (await api.post('/contacts', payload, config())).data,
};
